// CANONICAL COPY (GH #7115). src/constants/obligations/obl-information-transfer.js re-exports this file so the browser and the
// Function App share one compliance engine — one definition of "compliant". Edit here, never there.
'use strict';

module.exports = {
  id: 'obl-information-transfer',
  title: 'Verify information transfer rules and agreements',
  description:
    'Confirm that rules, procedures or agreements govern information transfer for all types of transfer facilities within the organisation and between the organisation and external parties, including encryption of sensitive data in transit, approved transfer channels, and agreements with recipients. Review transfer channels, protocols and agreements for adequacy.',
  category: 'technical',
  scfIds: ['SCF-AST-006'],
  cadence: { frequency: '1y', anchor: 'domain' },
  strategy: 'all',
  fulfilmentCriteria: [
    {
      type: 'document-published',
      description: 'Information transfer policy or procedure is published',
    },
    { type: 'document-within-sla', description: 'Policy review is not overdue' },
  ],
  domainActions: [{ type: 'approve-document', label: 'Approve Document' }],
};
